import { render, staticRenderFns } from "./change-brokerage.vue?vue&type=template&id=fc605dd6"
import script from "./change-brokerage.vue?vue&type=script&lang=js"
export * from "./change-brokerage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports